module.exports = __webpack_public_path__ + "img/list_api.60b77868.jpg";